import styled from "styled-components";

export const Container = styled.div`
  background: #f6f7ff;
  border: 1px solid #0b29fb;
  padding: 12px 16px;
  width: 100%;
`;

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Icon = styled.img`
  width: 20px;
  height: 20px;
`;

export const Title = styled.span`
  font-family: "MangueiraBold", sans-serif;
  font-weight: 700;
  color: #3d3d3d;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ChevronIcon = styled.img`
  cursor: pointer;
`;

type ContentProps = { isVisible: boolean };
export const Content = styled.div<ContentProps>`
  margin-top: 8px;
  margin-left: 26px;
  display: ${({ isVisible }) => (isVisible ? "block" : "none")};
  transition: all 0.2s;
`;

export const ContentText = styled.span`
  font-family: "Mangueira", sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  color: #3d3d3d;
`;
